module.exports = __webpack_public_path__ + "static/img/Aaclogo3.aae8b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo3.png
// module id = 7OK9
// module chunks = 1